// modules/Preloader/PreloaderResourceList.js
// 预加载器资源列表模块

export default class PreloaderResourceList {
    constructor() {
        // 资源列表已通过 RESOURCE_CONFIG 配置，这里主要提供动态生成的资源列表
    }
    
    /**
     * 生成地图图块资源列表
     * @returns {Array} 资源列表
     */
    generateMapTileResources() {
        const tiles = [
            // 地面图块
            { key: '草地', path: 'assets/maps/草地.png' },
            { key: '沙地', path: 'assets/maps/沙地.png' },
            { key: '洞土', path: 'assets/maps/洞土.png' },
            { key: '洞沙', path: 'assets/maps/洞沙.png' },
            { key: '空气', path: 'assets/maps/空气.png' },
            { key: '阳台', path: 'assets/maps/阳台.png' },
            { key: '店地板', path: 'assets/maps/店地板.png' },
            { key: '地砖', path: 'assets/maps/地砖.png' },
            { key: '大理石', path: 'assets/maps/大理石.png' },
            { key: '平台', path: 'assets/maps/平台.png' },
            
            // 水域素材
            { key: '水1', path: 'assets/maps/水1.png' },
            { key: '水2', path: 'assets/maps/水2.png' },
            { key: '水3', path: 'assets/maps/水3.png' },
            
            // 建筑物图块
            { key: '商店右上', path: 'assets/maps/商店右上.png' },
            { key: '商店右下', path: 'assets/maps/商店右下.png' },
            { key: '商店左上', path: 'assets/maps/商店左上.png' },
            { key: '帐篷左上', path: 'assets/maps/帐篷左上.png' },
            { key: '帐篷左下', path: 'assets/maps/帐篷左下.png' },
            { key: '帐篷右上', path: 'assets/maps/帐篷右上.png' },
            { key: '帐篷右下', path: 'assets/maps/帐篷右下.png' },
            { key: '柜台', path: 'assets/maps/柜台.png' },
            { key: '柜台2', path: 'assets/maps/柜台2.png' },
            { key: '工作台', path: 'assets/maps/工作台.png' },
            { key: '衣柜', path: 'assets/maps/衣柜.png' },
            { key: '战车中心左上', path: 'assets/maps/战车中心左上.png' },
            { key: '战车中心左中', path: 'assets/maps/战车中心左中.png' },
            { key: '战车中心右上', path: 'assets/maps/战车中心右上.png' },
            { key: '战车中心右中', path: 'assets/maps/战车中心右中.png' },
            { key: '战车中心中上', path: 'assets/maps/战车中心中上.png' },
            
            // 装饰物图块
            { key: '大树', path: 'assets/maps/大树.png' },
            { key: '树从', path: 'assets/maps/树从.png' },
            { key: '草从', path: 'assets/maps/草从.png' },
            { key: '杂草', path: 'assets/maps/杂草.png' },
            { key: '残骸1', path: 'assets/maps/残骸1.png' },
            { key: '木桩', path: 'assets/maps/木桩.png' },
            { key: '山左', path: 'assets/maps/山左.png' },
            { key: '山左2', path: 'assets/maps/山左2.png' },
            { key: '山右', path: 'assets/maps/山右.png' },
            { key: '山右2', path: 'assets/maps/山右2.png' },
            { key: '碎石', path: 'assets/maps/碎石.png' },
            { key: '盆栽右', path: 'assets/maps/盆栽右.png' },
            { key: '盆栽左', path: 'assets/maps/盆栽左.png' },
            { key: '盆栽大', path: 'assets/maps/盆栽大.png' },
            { key: '盆栽红', path: 'assets/maps/盆栽红.png' },
            { key: '盆栽上', path: 'assets/maps/盆栽上.png' },
            { key: '盆栽下', path: 'assets/maps/盆栽下.png' },
            { key: '栅栏', path: 'assets/maps/栅栏.png' },
            { key: '围栏', path: 'assets/maps/围栏.png' },
            { key: '油桶', path: 'assets/maps/油桶.png' },
            { key: '圆桌', path: 'assets/maps/圆桌.png' },
            { key: '圆凳', path: 'assets/maps/圆凳.png' },
            { key: '墓碑', path: 'assets/maps/墓碑.png' },
            { key: '左阴影草地', path: 'assets/maps/左阴影草地.png' },
            { key: '城镇悬崖', path: 'assets/maps/城镇悬崖.png' },
            { key: '左阴影沙地', path: 'assets/maps/左阴影沙地.png' },
            { key: '城镇向左箭头', path: 'assets/maps/城镇向左箭头.png' },
            { key: '垃圾堆', path: 'assets/maps/垃圾堆.png' },
            { key: '水岸上', path: 'assets/maps/水岸上.png' },
            { key: '水岸下', path: 'assets/maps/水岸下.png' },
            { key: '水岸左', path: 'assets/maps/水岸左.png' },
            { key: '水岸右', path: 'assets/maps/水岸右.png' },
            { key: '水岸左上', path: 'assets/maps/水岸左上.png' },
            { key: '水岸右上', path: 'assets/maps/水岸右上.png' },
            { key: '水岸左下', path: 'assets/maps/水岸左下.png' },
            { key: '水岸右下', path: 'assets/maps/水岸右下.png' },
            { key: '外墙左上', path: 'assets/maps/外墙左上.png' },
            { key: '外墙左中', path: 'assets/maps/外墙左中.png' },
            { key: '外墙左下', path: 'assets/maps/外墙左下.png' },
            { key: '外墙右上', path: 'assets/maps/外墙右上.png' },
            { key: '外墙右中', path: 'assets/maps/外墙右中.png' },
            { key: '外墙右下', path: 'assets/maps/外墙右下.png' },
            { key: '外墙上', path: 'assets/maps/外墙上.png' },
            { key: '外墙中', path: 'assets/maps/外墙中.png' },
            { key: '外墙下', path: 'assets/maps/外墙下.png' },
            { key: '外墙左', path: 'assets/maps/外墙左.png' },
            { key: '外墙右', path: 'assets/maps/外墙右.png' },
            { key: '外墙下下', path: 'assets/maps/外墙下下.png' },
            { key: '外墙左下下', path: 'assets/maps/外墙左下下.png' },
            { key: '外墙右下下', path: 'assets/maps/外墙右下下.png' },
            { key: '内墙', path: 'assets/maps/内墙.png' },
            { key: '内墙中', path: 'assets/maps/内墙中.png' },
            { key: '内墙下', path: 'assets/maps/内墙下.png' },
            { key: '通缉', path: 'assets/maps/通缉.png' },
            { key: '床上', path: 'assets/maps/床上.png' },
            { key: '床下', path: 'assets/maps/床下.png' },
            { key: '栏', path: 'assets/maps/栏.png' },
            { key: '栏左', path: 'assets/maps/栏左.png' },
            { key: '栏右', path: 'assets/maps/栏右.png' },
            { key: '洞壁', path: 'assets/maps/洞壁.png' },
            { key: '洞壁侧1', path: 'assets/maps/洞壁侧1.png' },
            { key: '洞壁侧2', path: 'assets/maps/洞壁侧2.png' },
            { key: '洞壁侧3', path: 'assets/maps/洞壁侧3.png' },
            { key: '洞壁侧4', path: 'assets/maps/洞壁侧4.png' },
            { key: '洞壁1', path: 'assets/maps/洞壁1.png' },
            { key: '洞壁2', path: 'assets/maps/洞壁2.png' },
            { key: '洞壁3', path: 'assets/maps/洞壁3.png' },
            { key: '洞壁4', path: 'assets/maps/洞壁4.png' },
            { key: '洞壁5', path: 'assets/maps/洞壁5.png' },
            { key: '洞壁6', path: 'assets/maps/洞壁6.png' },
            { key: '洞壁7', path: 'assets/maps/洞壁7.png' },
            { key: '洞壁8', path: 'assets/maps/洞壁8.png' },
            { key: '洞壁9', path: 'assets/maps/洞壁9.png' },
            { key: '洞壁10', path: 'assets/maps/洞壁10.png' },
            { key: '洞壁11', path: 'assets/maps/洞壁11.png' },
            { key: '洞崖', path: 'assets/maps/洞崖.png' },
            { key: '洞石', path: 'assets/maps/洞石.png' },
            { key: '黑洞', path: 'assets/maps/黑洞.png' },
            { key: '洞滑梯左上', path: 'assets/maps/洞滑梯左上.png' },
            { key: '洞滑梯左下', path: 'assets/maps/洞滑梯左下.png' },
            { key: '洞滑梯右上', path: 'assets/maps/洞滑梯右上.png' },
            { key: '洞滑梯右下', path: 'assets/maps/洞滑梯右下.png' },
            { key: '电脑上', path: 'assets/maps/电脑上.png' },
            { key: '电脑下', path: 'assets/maps/电脑下.png' },
            { key: '铁凳', path: 'assets/maps/铁凳.png' },
            { key: '铁桶', path: 'assets/maps/铁桶.png' },
            // 特殊图块
            { key: '传送', path: 'assets/maps/传送.png' },
            { key: '上楼梯右', path: 'assets/maps/上楼梯右.png' },
            { key: '上楼梯左', path: 'assets/maps/上楼梯左.png' },
            { key: '下楼梯右', path: 'assets/maps/下楼梯右.png' },
            { key: '下楼梯左', path: 'assets/maps/下楼梯左.png' },
            { key: '箱子', path: 'assets/maps/箱子.png' },
            { key: '人类', path: 'assets/maps/人类.png' },
            { key: '战车', path: 'assets/maps/战车.png' },
            { key: '旅馆', path: 'assets/maps/旅馆.png' },
            { key: '酒吧', path: 'assets/maps/酒吧.png' },
            { key: '猎人', path: 'assets/maps/猎人.png' },
            { key: '多功能', path: 'assets/maps/多功能.png' },
            { key: '山洞', path: 'assets/maps/山洞.png' },
            { key: '地穴左', path: 'assets/maps/地穴左.png' },
            { key: '地穴右', path: 'assets/maps/地穴右.png' },
            { key: '停车场', path: 'assets/maps/停车场.png' },
            { key: '战车中心', path: 'assets/maps/战车中心中中.png' },
            
            // 道路图块
            { key: '公路水平段', path: 'assets/maps/公路水平段.png' },
            { key: '公路垂直段', path: 'assets/maps/公路垂直段.png' },
            
            // 城镇图块
            { key: '村1', path: 'assets/maps/村1.png' },
            { key: '镇1', path: 'assets/maps/镇1.png' }
        ];
        
        return tiles;
    }
    
    /**
     * 生成战斗资源列表
     * @returns {Array} 资源列表
     */
    generateBattleResources() {
        const resources = [
            // 战斗场景玩家
            { key: '主角1', path: 'assets/battle/player/主角1.png' },
            { key: '主角2', path: 'assets/battle/player/主角2.png' },
            { key: '主角3', path: 'assets/battle/player/主角3.png' },
            { key: '主角4', path: 'assets/battle/player/主角4.png' },
            
            // 敌人（普通）
            { key: '战狗', path: 'assets/battle/enemies/战狗.png' },
            { key: '野战炮', path: 'assets/battle/enemies/野战炮.png' },
            { key: '彷生蜗牛', path: 'assets/battle/enemies/彷生蜗牛.png' },
            { key: '军蚁', path: 'assets/battle/enemies/军蚁.png' },
            { key: '加农炮', path: 'assets/battle/enemies/加农炮.png' },
            { key: '狙击鸟', path: 'assets/battle/enemies/狙击鸟.png' },
            { key: '毒蜘蛛', path: 'assets/battle/enemies/毒蜘蛛.png' },
            { key: '机械虫', path: 'assets/battle/enemies/机械虫.png' },
            { key: '激光蚯', path: 'assets/battle/enemies/激光蚯.png' },
            { key: '85自行炮', path: 'assets/battle/enemies/85自行炮.png' },
            { key: 'ATM坦克', path: 'assets/battle/enemies/ATM坦克.png' },
            { key: 'AT坦克', path: 'assets/battle/enemies/AT坦克.png' },
            { key: '化学炮', path: 'assets/battle/enemies/化学炮.png' },
            { key: '反坦克兵', path: 'assets/battle/enemies/反坦克兵.png' },
            { key: '反坦克炮', path: 'assets/battle/enemies/反坦克炮.png' },
            { key: '变形虫', path: 'assets/battle/enemies/变形虫.png' },
            { key: '古炮', path: 'assets/battle/enemies/古炮.png' },
            { key: '合金鸟', path: 'assets/battle/enemies/合金鸟.png' },
            { key: '后备车', path: 'assets/battle/enemies/后备车.png' },
            { key: '喷火怪', path: 'assets/battle/enemies/喷火怪.png' },
            { key: '噪音器', path: 'assets/battle/enemies/噪音器.png' },
            { key: '地雷龟', path: 'assets/battle/enemies/地雷龟.png' },
            { key: '塔吊', path: 'assets/battle/enemies/塔吊.png' },
            { key: '声波炮', path: 'assets/battle/enemies/声波炮.png' },
            { key: '声波蛇', path: 'assets/battle/enemies/声波蛇.png' },
            { key: '声纳蛇', path: 'assets/battle/enemies/声纳蛇.png' },
            { key: '大象', path: 'assets/battle/enemies/大象.png' },
            { key: '导弹蛙', path: 'assets/battle/enemies/导弹蛙.png' },
            { key: '导弹车', path: 'assets/battle/enemies/导弹车.png' },
            { key: '巨型河马', path: 'assets/battle/enemies/巨型河马.png' },
            { key: '巨蚁', path: 'assets/battle/enemies/巨蚁.png' },
            { key: '巨蟹', path: 'assets/battle/enemies/巨蟹.png' },
            { key: '扫描仪', path: 'assets/battle/enemies/扫描仪.png' },
            { key: '拦截碟', path: 'assets/battle/enemies/拦截碟.png' },
            { key: '拦截车', path: 'assets/battle/enemies/拦截车.png' },
            { key: '指挥车', path: 'assets/battle/enemies/指挥车.png' },
            { key: '攻击机', path: 'assets/battle/enemies/攻击机.png' },
            { key: '无坐力炮', path: 'assets/battle/enemies/无坐力炮.png' },
            { key: '智能人', path: 'assets/battle/enemies/智能人.png' },
            { key: '暗堡', path: 'assets/battle/enemies/暗堡.png' },
            { key: '机器人', path: 'assets/battle/enemies/机器人.png' },
            { key: '机器鸟', path: 'assets/battle/enemies/机器鸟.png' },
            { key: '机械河马', path: 'assets/battle/enemies/机械河马.png' },
            { key: '机械蟹', path: 'assets/battle/enemies/机械蟹.png' },
            { key: '杀人虫', path: 'assets/battle/enemies/杀人虫.png' },
            { key: '步枪鸟', path: 'assets/battle/enemies/步枪鸟.png' },
            { key: '歼灭者', path: 'assets/battle/enemies/歼灭者.png' },
            { key: '毒液枪', path: 'assets/battle/enemies/毒液枪.png' },
            { key: '毒蜂', path: 'assets/battle/enemies/毒蜂.png' },
            { key: '毒蜗牛', path: 'assets/battle/enemies/毒蜗牛.png' },
            { key: '毒蝙蝠', path: 'assets/battle/enemies/毒蝙蝠.png' },
            { key: '水怪', path: 'assets/battle/enemies/水怪.png' },
            { key: '水鬼', path: 'assets/battle/enemies/水鬼.png' },
            { key: '沙漠之舟', path: 'assets/battle/enemies/沙漠之舟.png' },
            { key: '沙漠虎', path: 'assets/battle/enemies/沙漠虎.png' },
            { key: '沙漠车', path: 'assets/battle/enemies/沙漠车.png' },
            { key: '激光系统', path: 'assets/battle/enemies/激光系统.png' },
            { key: '激光虫', path: 'assets/battle/enemies/激光虫.png' },
            { key: '火焰枪', path: 'assets/battle/enemies/火焰枪.png' },
            { key: '火焰炮', path: 'assets/battle/enemies/火焰炮.png' },
            { key: '炸弹龟', path: 'assets/battle/enemies/炸弹龟.png' },
            { key: '狙击车', path: 'assets/battle/enemies/狙击车.png' },
            { key: '瓦鲁', path: 'assets/battle/enemies/瓦鲁.png' },
            { key: '生物枪', path: 'assets/battle/enemies/生物枪.png' },
            { key: '生物炮', path: 'assets/battle/enemies/生物炮.png' },
            { key: '电磁花', path: 'assets/battle/enemies/电磁花.png' },
            { key: '电脑墙', path: 'assets/battle/enemies/电脑墙.png' },
            { key: '监视器', path: 'assets/battle/enemies/监视器.png' },
            { key: '碉堡', path: 'assets/battle/enemies/碉堡.png' },
            { key: '磁铁', path: 'assets/battle/enemies/磁铁.png' },
            { key: '神武炮', path: 'assets/battle/enemies/神武炮.png' },
            { key: '神秘人', path: 'assets/battle/enemies/神秘人.png' },
            { key: '神风弹', path: 'assets/battle/enemies/神风弹.png' },
            { key: '离子坦克', path: 'assets/battle/enemies/离子坦克.png' },
            { key: '离子虫', path: 'assets/battle/enemies/离子虫.png' },
            { key: '章鱼坦克', path: 'assets/battle/enemies/章鱼坦克.png' },
            { key: '章鱼炮', path: 'assets/battle/enemies/章鱼炮.png' },
            { key: '粉碎机', path: 'assets/battle/enemies/粉碎机.png' },
            { key: '蛙人', path: 'assets/battle/enemies/蛙人.png' },
            { key: '蜈蚣', path: 'assets/battle/enemies/蜈蚣.png' },
            { key: '裂杀者', path: 'assets/battle/enemies/裂杀者.png' },
            { key: '装甲车', path: 'assets/battle/enemies/装甲车.png' },
            { key: '起重机', path: 'assets/battle/enemies/起重机.png' },
            { key: '超导虫', path: 'assets/battle/enemies/超导虫.png' },
            { key: '车载炮', path: 'assets/battle/enemies/车载炮.png' },
            { key: '追踪弹', path: 'assets/battle/enemies/追踪弹.png' },
            { key: '酸蚁', path: 'assets/battle/enemies/酸蚁.png' },
            { key: '金蚁', path: 'assets/battle/enemies/金蚁.png' },
            { key: '铁甲炮', path: 'assets/battle/enemies/铁甲炮.png' },
            { key: '防御器', path: 'assets/battle/enemies/防御器.png' },
            { key: '雷达花', path: 'assets/battle/enemies/雷达花.png' },
            { key: '霸王花', path: 'assets/battle/enemies/霸王花.png' },
            { key: '音速车', path: 'assets/battle/enemies/音速车.png' },
            { key: '飞狗', path: 'assets/battle/enemies/飞狗.png' },
            { key: '食人花', path: 'assets/battle/enemies/食人花.png' },
            { key: '食人蚁', path: 'assets/battle/enemies/食人蚁.png' },
            { key: '高速车', path: 'assets/battle/enemies/高速车.png' },
            { key: '鬼手', path: 'assets/battle/enemies/鬼手.png' },
            { key: '魔鬼花', path: 'assets/battle/enemies/魔鬼花.png' },
            { key: '龟式战车', path: 'assets/battle/enemies/龟式战车.png' },
            { key: '熊猫战士', path: 'assets/battle/enemies/熊猫战士.png' },
            
            // Boss敌人
            { key: '巨型炮', path: 'assets/battle/enemies/巨型炮.png' },
            { key: '诺亚', path: 'assets/battle/enemies/诺亚.png' },
            { key: '戈麦斯', path: 'assets/battle/enemies/戈麦斯.png' },
            { key: '巴多 帕鲁迪斯', path: 'assets/battle/enemies/巴多  帕鲁迪斯.png' },
            { key: '马歇尔', path: 'assets/battle/enemies/马歇尔.png' }
        ];
        
        return resources;
    }
}

